import { For, createMemo } from 'solid-js';
import { date } from 'common';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import { Day } from './Day';
import { MonthHeading } from './MonthHeading';
import styles from '../st-attendance-grid.module.css';

function WorkWeek(props: { date: Date, sectGU: string }) {
    const days = createMemo(() => {
        const dt = date.startOfWeek(props.date);
        return [1, 2, 3, 4, 5].map(i => date.addDays(dt, i));
    });

    return <>
        <For each={days()}>{(d) => <Day date={d} sectGU={props.sectGU} />}</For>
    </>
}

export function CalendarContent(props: { sectGU: string }) {
    const ctx = requireAttendanceGridContext();

    return (
        <div class={styles['calendar-grid']}>
            <MonthHeading excludeWeekend />
            <WorkWeek date={ctx.day()} sectGU={props.sectGU} />
        </div>
    );
}
